// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipf-accordion {
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
}

.ipf-accordion > div {
  margin-top: -1px;
}

.ipf-accordion > div:first-child {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Accordion/Accordion.css","webpack://./services/frontend/app/components/Accordion/Accordion.css"],"names":[],"mappings":"AADA;ECEE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ipf-accordion {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.ipf-accordion > div {\n  margin-top: -1px;\n}\n\n.ipf-accordion > div:first-child {\n    margin-top: 0;\n  }\n",".ipf-accordion {\n  box-sizing: border-box;\n  flex-direction: column;\n  display: flex;\n}\n\n.ipf-accordion > div {\n  margin-top: -1px;\n}\n\n.ipf-accordion > div:first-child {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
